import React from 'react';
import styles from './mobile-card-skeleton.module.css';

type MobileCardSkeletonProps = {
  count?: number;
  gap?: number;
  mode?: 'initial' | 'append';
};

export const MobileCardSkeleton: React.FC<MobileCardSkeletonProps> = ({
  count = 1,
  gap = 20,
  mode = 'initial',
}) => {
  return (
    <div
      className={[styles.list, mode === 'initial' ? styles.listInitial : ''].join(' ')}
      style={{ gap }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <article key={index} className={styles.card}>
          <div className={[styles.media, styles.shimmer].join(' ')} />
          <div className={styles.body}>
            <div className={[styles.titleLine, styles.shimmer].join(' ')} />
            <div className={[styles.skuLine, styles.shimmer].join(' ')} />
            <div className={styles.footerRow}>
              <div className={[styles.priceLine, styles.shimmer].join(' ')} />
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};
